import ArrowsArrowUpSLine from './arrows-arrow-up-s-line.component.js'

export * from './arrows-arrow-up-s-line.component.js'
export default ArrowsArrowUpSLine

ArrowsArrowUpSLine.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-arrow-up-s-line': ArrowsArrowUpSLine
  }
}
